import { processComponentOption, getComponent, getWxsMixin } from "@mpxjs/webpack-plugin/lib/runtime/optionProcessor";
var wxsModules = {};
global.currentModuleId = "_7752a2b9";
global.currentSrcMode = "wx";
global.currentInject = { "moduleId": "_7752a2b9" };
/** script content **/
require("./button.ts?ctorType=component&index=0&isComponent&lang=ts&mpx&outputPath=components%2Findex7752a2b9%2Findex&resourcePath=%2Fhome%2Frunner%2Fwork%2Fmpx-cube-ui%2Fmpx-cube-ui%2Fpackages%2Fmpx-cube-ui%2Fsrc%2Fcomponents%2Fbutton%2Findex.mpx&type=script");
export default processComponentOption({
    option: global.__mpxOptionsMap["_7752a2b9"],
    ctorType: "component",
    outputPath: "components/index7752a2b9/index",
    pageConfig: {},
    // @ts-ignore
    componentsMap: { 'cube-icon': getComponent(require("../icon/index.mpx?isComponent&outputPath=components%2Findex1d853680%2Findex")), 'loading': getComponent(require("./loading/index.mpx?isComponent&outputPath=components%2Findex1b974da6%2Findex")), 'mpx-button': getComponent(require("@mpxjs/webpack-plugin/lib/runtime/components/web/mpx-button?isComponent"), { __mpxBuiltIn: true }) },
    componentGenerics: {},
    genericsInfo: undefined,
    wxsMixin: getWxsMixin(wxsModules),
    hasApp: true
});
